import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { RUN_SET_PRIORITIZE } from "./gql";

const useSetPrioritizeRun = createDefaultMutationHook(RUN_SET_PRIORITIZE);
export const useBulkSetPrioritizeRun = createBulkMutationHook(RUN_SET_PRIORITIZE);

export default useSetPrioritizeRun;
